export enum PaymentType {
  MP = 'Manual Payment',
  CP = 'Customer Payment',
}
